module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SB-1b7d11856b4e9b673785a736d3200d6a.png";